import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/crm/auth.service';
import swal from 'sweetalert2';  

@Component({
  selector: 'app-preventa',
  templateUrl: './preventa.component.html',
  styleUrls: ['./preventa.component.scss']
})
export class PreventaComponent implements OnInit {

  constructor(public authService: AuthService,public router:Router) { }

  ngOnInit() {
    this.id_cliente=Number(localStorage.getItem("id_cliente"));
    this.secc_(2);
    this.ls_cliente_preventa();

  }
  fn_filter(){
    
  }
  preventas;
  bdn_edit=0;
  seguimiento(itm){ 
    localStorage.setItem("cliente",itm.id);
    localStorage.setItem("cliente_",JSON.stringify(itm) );
    this.router.navigate(['/seguimiento']);
  }
  edita_preventa(itm){
    this.secc_(1);
    this.bdn_edit=1;
    this.preventa.id=itm.id;
    this.preventa.nombre=itm.nombre;
    this.preventa.paterno=itm.paterno;
    this.preventa.materno=itm.materno;
    this.preventa.rs=itm.razonsocial;
    this.preventa.rfc=itm.rfc;
    this.preventa.cargo=itm.cargo,
    this.preventa.correo=itm.correo;
    this.preventa.tel1=itm.telefono;
    this.preventa.tel2=itm.telefono2;
    this.preventa.ext1=itm.ext1;
    this.preventa.ext2=itm.ext2;
    this.preventa.pais=itm.pais;
    this.preventa.estado=itm.estado;
    this.preventa.municipio=itm.municipio;
    this.preventa.colonia=itm.colonia;
    this.preventa.calle=itm.calle;
    this.preventa.cp=itm.cp;
    this.preventa.medio=itm.medio;
  }
  id_cliente;
  ls_cliente_preventa(){
    this.preventas=[];
    let postData={
      id_cliente:this.id_cliente
    };
    this.authService.service("/api/get_cliente_preventa_id_cliente",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.preventas=data;
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! ', '', 'error');
        });   

  }
  secc;
  valida_cliente(){
    if(this.preventa.rs=="" || this.preventa.rs==null || this.preventa.rs==undefined){
      swal.fire('¡Completar Razón Social! ', '', 'warning');
      return false;
    }
    if(this.preventa.rfc=="" || this.preventa.rfc==null || this.preventa.rfc==undefined){
      swal.fire('¡Completar RFC! ', '', 'warning');
      return false;
    }
    if(this.preventa.nombre=="" || this.preventa.nombre==null || this.preventa.nombre==undefined){
      swal.fire('¡Completar nombre! ', '', 'warning');
      return false;
    }
    if(this.preventa.paterno=="" || this.preventa.paterno==null || this.preventa.paterno==undefined){
      swal.fire('¡Completar apellidos! ', '', 'warning');
      return false;
    }
    if(this.preventa.correo=="" || this.preventa.correo==null || this.preventa.correo==undefined){
      swal.fire('¡Completar al menos un correo! ', '', 'warning');
      return false;
    }  
    if(this.preventa.tel1=="" || this.preventa.tel1==null || this.preventa.tel1==undefined){
      swal.fire('¡Completar al menos un teléfono! ', '', 'warning');
      return false;
    }
    return true
  }
  fn_upd_cliente(){
    if(this.valida_cliente()==true){
      let postData={
        nombre:this.preventa.nombre,
        paterno:this.preventa.paterno,
        materno:this.preventa.materno,
        razonsocial:this.preventa.rs,
        rfc:this.preventa.rfc,
        cargo:this.preventa.cargo,
        correo:this.preventa.correo,
        telefono:this.preventa.tel1,
        telefono2:this.preventa.tel2,
        ext1:this.preventa.ext1,
        ext2:this.preventa.ext2,
        pais:this.preventa.pais,
        estado:this.preventa.estado,
        municipio:this.preventa.municipio,
        colonia:this.preventa.colonia,
        calle:this.preventa.calle,
        cp:Number(this.preventa.cp),
        medio:this.preventa.medio,
        id:this.preventa.id
      };
      this.authService.service("/api/upd_cliente_preventa",postData)
      .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.secc_(2);
            this.ls_cliente_preventa();
            swal.fire('¡ok! ', '', 'success');
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! ', '', 'error');
        });   

    }
  }
  fn_gda_cliente(){
    if(this.valida_cliente()==true){
      let postData={
        id_cliente:this.id_cliente,
        nombre:this.preventa.nombre,
        paterno:this.preventa.paterno,
        materno:this.preventa.materno,
        razonsocial:this.preventa.rs,
        rfc:this.preventa.rfc,
        cargo:this.preventa.cargo,
        correo:this.preventa.correo,
        telefono:this.preventa.tel1,
        telefono2:this.preventa.tel2,
        ext1:this.preventa.ext1,
        ext2:this.preventa.ext2,
        pais:this.preventa.pais,
        estado:this.preventa.estado,
        municipio:this.preventa.municipio,
        colonia:this.preventa.colonia,
        calle:this.preventa.calle,
        cp:Number(this.preventa.cp),
        medio:this.preventa.medio
      };
      this.authService.service("/api/gda_cliente_preventa_id_cliente",postData)
      .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.secc_(2);
            this.ls_cliente_preventa();
            swal.fire('¡ok! ', '', 'success');
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! ', '', 'error');
        });   

    }
  }
  preventa={
    id:0,
    cargo:"",
    nombre:"",
    paterno:"",
    materno:"",
    rs:"",
    rfc:"",
    correo:"",
    tel1:"",
    tel2:"",
    ext1:"",
    ext2:"",
    pais:"",
    estado:"",
    municipio:"",
    colonia:"",
    calle:"",
    cp:"",
    medio:""
  }
  limpia_form(){
    this.preventa.id=0;
    this.preventa.nombre="";
    this.preventa.paterno="";
    this.preventa.materno="";
    this.preventa.rs="";
    this.preventa.rfc="";
    this.preventa.correo="";
    this.preventa.tel1="";
    this.preventa.tel2="";
    this.preventa.ext1="";
    this.preventa.ext2="";
    this.preventa.cargo="";
    this.preventa.pais="";
    this.preventa.estado="";
    this.preventa.municipio="";
    this.preventa.colonia="";
    this.preventa.calle="";
    this.preventa.cp="";
    this.preventa.medio="";
  }
  secc_(c){
    this.secc=c;
    switch (c) {
      case 1:
        this.bdn_edit=0;
        this.limpia_form();        
        break;
      default:
        break;
    }
  }
}
